import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from "react-router";
import ROUTES_PATHS from "../constants/routes";
import Layout from "../pages/Layout";
import Login from "../pages/Login";
import NewPasswordOffline from "../pages/NewPassword/NewPasswordOffline";
import NewPasswordOnline from "../pages/NewPassword/NewPasswordOnline";
import { RegisterSuccessWithClubCard } from "../pages/RegisterSuccessWithClubCard/RegisterSuccessWithClubCard";
import { RegisterSuccessWithQrCode } from "../pages/RegisterSuccessWithQrCode/RegisterSuccessWithQrCode";
import Registration from "../pages/Registration";
import ResetPassword from "../pages/ResetPassword";
import SmsPhoneValidation from "../pages/SmsPhoneValidation/SmsPhoneValidation";
import ExpiredEmail from "../pages/UpdateEmail/ErrorPages/ExpiredEmail";
import VerifiedEmail from "../pages/UpdateEmail/ErrorPages/VerifiedEmail";
export const routes = [
    {
        path: "/",
        component: Layout,
        routes: [
            {
                path: `${ROUTES_PATHS.login}/:token`,
                component: Login,
            },
            {
                path: ROUTES_PATHS.login,
                component: Login,
            },
            {
                path: `${ROUTES_PATHS.register}/:step?`,
                component: Registration,
            },
            {
                path: ROUTES_PATHS.smsPhoneValidation,
                component: SmsPhoneValidation,
            },
            {
                path: ROUTES_PATHS.resetPassword,
                component: ResetPassword,
            },
            {
                path: `${ROUTES_PATHS.newPasswordOffline}/:token`,
                component: NewPasswordOffline,
            },
            {
                path: `${ROUTES_PATHS.newPassword}/:token`,
                component: NewPasswordOnline,
            },
            {
                path: ROUTES_PATHS.verifiedEmail,
                component: VerifiedEmail,
            },
            {
                path: ROUTES_PATHS.expiredEmail,
                component: ExpiredEmail,
            },
            {
                path: ROUTES_PATHS.offlineRegistrationSuccess,
                component: RegisterSuccessWithQrCode,
            },
            {
                path: ROUTES_PATHS.offlineRegistrationSuccessWithClubCard,
                component: RegisterSuccessWithClubCard,
            },
            {
                path: "/",
                render: () => _jsx(Redirect, { to: ROUTES_PATHS.login }),
            },
        ],
    },
];
